export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '1024社区是什么？',
    answer: '1024社区是一个专为程序员打造的技术交流与资源分享平台。我们汇聚了海量编程教程、开源项目推荐、技术干货文章以及行业最新资讯，旨在为中文开发者提供一个高质量的学习和交流社区。无论你是编程新手还是资深架构师，都能在这里找到有价值的内容。',
  },
  {
    question: '如何在1024社区发布文章？',
    answer: '目前1024社区的文章由专业编辑团队和特邀技术作者进行内容创作。我们欢迎有技术专长的开发者成为社区作者，你可以通过关于我们页面的联系方式提交申请，经过审核后即可获得发布权限。我们会为优秀作者提供曝光推荐和技术影响力建设支持。',
  },
  {
    question: '1024社区的内容覆盖哪些技术领域？',
    answer: '1024社区的内容覆盖前端开发、后端开发、移动开发、AI/机器学习、开源项目、DevOps、数据库、编程语言等主流技术领域。我们持续追踪技术发展趋势，确保内容的前沿性和实用性。',
  },
  {
    question: '1024社区是否收费？',
    answer: '1024社区目前对所有用户完全免费开放，所有技术文章和资源都可以免费阅读和学习。我们致力于打造一个开放、包容的技术社区，让知识无障碍地传播。',
  },
  {
    question: '如何参与1024社区的开源项目？',
    answer: '你可以通过关于我们页面查看1024社区在 GitHub 上的开源项目，直接参与代码贡献、文档完善或 Issue 讨论。我们鼓励开发者通过实际贡献来提升技术能力和社区影响力。',
  },
];

export const reputationCards = [
  {
    title: '百万开发者',
    description: '社区累计注册开发者超过 100 万，日均活跃用户 15 万+',
    icon: 'ri-group-line',
  },
  {
    title: '万篇技术文章',
    description: '累计收录优质技术文章超过 30,000 篇，覆盖八大技术领域',
    icon: 'ri-article-line',
  },
  {
    title: '500+ 开源项目',
    description: '托管和维护超过 500 个优质开源项目，GitHub Stars 累计破百万',
    icon: 'ri-git-repository-line',
  },
  {
    title: '98% 好评率',
    description: '社区用户满意度调查中，98% 的用户表示会推荐给其他开发者',
    icon: 'ri-heart-line',
  },
];